import { createStyles } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = () =>
  createStyles({
    root: {},
    content: {
      display: 'flex',
      flexDirection: 'column',
    },
    icon: {},
    link: {
      color: colours.neutral[900],
      cursor: 'pointer',
      fontWeight: 500,
      textDecorationLine: 'underline',
    },
  });
